import { AM } from './polyline';
import * as ol from 'openlayers';
import { GPS } from './gps';

export let colorArr: Array<string> = [];

function getColorStyle(feature, colorData): string {
  const color = colorData[feature.get('code')];
  if (!color) {
      return  '#62e4c7';
  }
  return color;
}

function createFill(feature): ol.style.Fill {
  return new ol.style.Fill({
      color: getColorStyle.apply(this, [feature, colorArr])
  });
}

export let polygonStyle = function (feature): ol.style.Style {
  return new ol.style.Style({
      stroke: new ol.style.Stroke({
          color: 'transparent',
          width: 1
      }),
      fill: createFill.apply(this, [feature]),
  });
};

export let getLayer = function (url: string, styleFunction): ol.layer.Vector {
  return new ol.layer.Vector({
    source: new ol.source.Vector({
      url: url,
      format: new ol.format.GeoJSON({
        defaultDataProjection: 'EPSG:3875',
        geometryName: 'EPSG:3875'
      })
    }),
    style: styleFunction
  });
};


export function createPolygon(
  coordinates: Array<Array<Array<number>>>,
  id: string = '',
  strokeColor: string = 'rgba(23, 168, 162, 0.56)',
  fillColor: string = 'rgba(184, 233, 134, 0.56)'): ol.layer.Vector {
  let polygon = null;
  let polygonFeature = null;
  let layer = null;
  const style = new ol.style.Style({
    stroke: new ol.style.Stroke({
      width: 1,
      color: strokeColor
    }),
    fill: new ol.style.Fill({
      color: fillColor
    })
  });
  layer = new ol.layer.Vector({
    source: new ol.source.Vector(),
    style: style
  });
  polygon = new ol.geom.Polygon();
  polygon.setCoordinates(coordinates);
  polygonFeature = new ol.Feature(polygon);
  polygonFeature.setId(id);
  layer.getSource().addFeature(polygonFeature);
  return layer;
}

export function createPolygonGeojson(
  geoJsonObj: any,
  fillColor: string = 'rgba(41, 212, 178, 0.4)',
  stroke: string = 'rgba(23, 168, 162, 1)'
): ol.layer.Vector {
  const styles = {
    Polygon: new ol.style.Style({
      fill: new ol.style.Fill({
        color: fillColor
      }),
      stroke: new ol.style.Stroke({
        color: stroke,
        width: 2
      })
    })
  };

  const vectorSource = new ol.source.Vector({
    features: new ol.format.GeoJSON().readFeatures(geoJsonObj)
  });

  return new ol.layer.Vector({
    source: vectorSource,
    style: function (feature) {
      return styles[feature.getGeometry().getType()];
    }
  });
}

export function fit(map, points, opts?): void {
  const len = points.length;
  if (len <= 0) {
    return;
  }
  opts = opts || {};

  let way = opts.way;
  if (way === undefined) {
    way = 1;
  }
  const padding = opts.padding || [50, 50, 50, 50];
  let minLng = 180,
    maxLng = -180,
    minLat = 180,
    maxLat = -180,
    sumLng = 0,
    sumLat = 0;
  for (let i = 0; i < len; i++) {
    const lng = points[i][0];
    const lat = points[i][1];
    sumLng += lng;
    sumLat += lat;
    if (lng > maxLng) {
      maxLng = lng;
    }
    if (lng < minLng) {
      minLng = lng;
    }
    if (lat > maxLat) {
      maxLat = lat;
    }
    if (lat < minLat) {
      minLat = lat;
    }
  }
  const view = map.getView();
  switch (way) {
    case 1: {
      view.fit([minLng, minLat, maxLng, maxLat], {
        padding: padding
      });
      break;
    }
    case 2: {
      const center = [sumLng / len, sumLat / len];
      const length = new ol.Sphere(6378137).haversineDistance(
        [minLng, minLat],
        [maxLng, maxLat]
      );
      const zoom = 18 - Math.floor(length / 3000);
      view.setCenter(center);
      view.setZoom(zoom);
      break;
    }
  }
}

export function zoomIn(map) {
  const view = map.getView();
  view.animate({
    zoom: view.getZoom() + 1,
    duration: 200
  });
}

export function zoomOut(map) {
  const view = map.getView();
  view.animate({
    zoom: view.getZoom() - 1,
    duration: 200
  });
}

export function createGPSPoints(
  gpscoordinatelist,
  isGCJ02Point: boolean = false,
  am: AM = null
): Array<Array<number>> {
  const gpspoints = [];
  for (let i = 0; i < gpscoordinatelist.length; i++) {
    const item = gpscoordinatelist[i];
    const lng = item.X;
    const lat = item.Y;
    if (
      lng != null &&
      lng != '' &&
      lng != 0 &&
      (lat != null && lat != '' && lat != 0)
    ) {
      if (am != null) {
        am.getLngAndLatMaxMin(item);
      }
      if (isGCJ02Point) {
        const obj = GPS.gcj_encrypt(lat, lng);
        gpspoints.push([obj.lon, obj.lat]);
      } else {
        gpspoints.push([lng, lat]);
      }
    }
  }
  return gpspoints;
}

export function createPolylinePoints(
  amworkdatalist,
  isGCJ02Point: boolean = false,
  callback: Function = null
): any {
  const PolylinePoints = { gpsPoints: [], optRtDephts: [], isNJOpt: [], IsInFence: [], IsOverSpeed: []};
  PolylinePoints.gpsPoints = createGPSPoints(amworkdatalist, isGCJ02Point);
  for (let i = 0; i < amworkdatalist.length; i++) {

    if (amworkdatalist[i].OptRtDepth) {
      PolylinePoints.optRtDephts.push(amworkdatalist[i].OptRtDepth);
    }

    if ( amworkdatalist[i].IsNJOpt== true) {
      PolylinePoints.isNJOpt.push(amworkdatalist[i].IsNJOpt);
    } else {
      if ( amworkdatalist[i].IsNJOpt == false) {
        PolylinePoints.isNJOpt.push(amworkdatalist[i].IsNJOpt);
      }
    }

    if ( amworkdatalist[i].IsInFence==true) {
      PolylinePoints.isNJOpt.push(amworkdatalist[i].IsInFence);
    } else if (amworkdatalist[i].IsInFence==false){
      PolylinePoints.isNJOpt.push(amworkdatalist[i].IsInFence);
    }

    if ( amworkdatalist[i].IsOverSpeed==true) {
      PolylinePoints.isNJOpt.push(amworkdatalist[i].IsOverSpeed);
    } else if (amworkdatalist[i].IsOverSpeed==false) {
      PolylinePoints.isNJOpt.push(amworkdatalist[i].IsOverSpeed);
    }

    if (callback) {
      if (parseInt(amworkdatalist[i].PId) > 0) {
        const x = parseFloat(amworkdatalist[i].X);
        const y = parseFloat(amworkdatalist[i].Y);
        if (x && y) {
          callback.call(this, amworkdatalist[i].PId, [x, y]);
        }
      }
    }
  }
  return PolylinePoints;
}

export function getLngAndLatMaxMin(coordinates: Array<Array<number>>): Array<number> {
  let xMax = 0;
  let xMin = 400;
  let yMax = 0;
  let yMin = 400;
  for (let i = 0; i < coordinates.length; i++) {
    for (let j = 0; j < coordinates[i].length; j++) {
      if (coordinates[i][j][0] > xMax) {
        xMax = coordinates[i][j][0];
      }
      if (coordinates[i][j][1] > yMax) {
        yMax = coordinates[i][j][1];
      }
      if (coordinates[i][j][0] < xMin) {
        xMin = coordinates[i][j][0];
      }
      if (coordinates[i][j][1] < yMin) {
        yMin = coordinates[i][j][1];
      }
    }
  }

  return [xMax, yMax, xMin === 400 ? 0 : xMin, yMin === 400 ? 0 : yMin];
}

function _getCenterPoint(path): Array<number> {
  let x = 0.0;
  let y = 0.0;
  for (let i = 0; i < path.length; i++) {
    for (let j = 0; j < path[i].length; j++) {
      x = x + parseFloat(path[i][j][0]);
      y = y + parseFloat(path[i][j][1]);
    }
  }
  x = x / path.length;
  y = y / path.length;
  return [x, y];
}

export function createGeoJson(coordinates: Array<Array<number>>, properties: any = {}, type: string = 'Polygon'): any {
  return {
    type: 'Feature',
    properties: properties,
    bbox: getLngAndLatMaxMin(coordinates),
    geometry: {
      type: type,
      coordinates: coordinates
    }
  };
}

export function rayCasting(p, poly): boolean {
  const px = p.x;
  const py = p.y;
  let flag = false;

  for (let i = 0, l = poly.length, j = l - 1; i < l; j = i, i++) {
    const sx = poly[i].X,
      sy = poly[i].Y,
      tx = poly[j].X,
      ty = poly[j].Y;

    // ç¹ä¸å¤è¾¹å½¢é¡¶ç¹éå
    if ((sx === px && sy === py) || (tx === px && ty === py)) {
      return true;
    }

    // å¤æ­çº¿æ®µä¸¤ç«¯ç¹æ¯å¦å¨å°çº¿ä¸¤ä¾§
    if ((sy < py && ty >= py) || (sy >= py && ty < py)) {
      // çº¿æ®µä¸ä¸å°çº¿ Y åæ ç¸åçç¹ç X åæ 
      const x = sx + (py - sy) * (tx - sx) / (ty - sy);

      // ç¹å¨å¤è¾¹å½¢çè¾¹ä¸
      if (x === px) {
        return true;
      }

      // å°çº¿ç©¿è¿å¤è¾¹å½¢çè¾¹ç
      if (x > px) {
        flag = !flag;
      }
    }
  }

  // å°çº¿ç©¿è¿å¤è¾¹å½¢è¾¹ççæ¬¡æ°ä¸ºå¥æ°æ¶ç¹å¨å¤è¾¹å½¢å
  return flag ? true : false;
}
